
const headers = [
    {
      label: 'ชื่อ',
      field: 'name'
    },
    {
      label: 'หมายเลขนิติบุคคล',
      field: 'juristicId'
    },
    {
      label: 'จัดการ',
      field: 'action'
    },
  ]

  export default headers